module.exports = __webpack_public_path__ + "img/mandomedio.b0ae163b.png";